import { gql } from '@apollo/client';

export const GET_IMQS_ZIP = gql`
  mutation IMQS_SERVICE_getImqsZip($groupId: String!, $entityId: String!) {
    getIMQsZip(groupId: $groupId, entityId: $entityId)
  }
`;
